// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.show {
  display: block !important;
}

.hide {
  display: none;
}
.enter-digit {
  text-align: center;
  margin-top: 20px;
}
.error-msg {
  color: red;
}
.twofa-guide-button.disable-btn {
  margin-bottom: 20px;
}
button.rejected-application {
  font-size: 18px;
  color: #383838;
  background-color: #e51010a6;
  border: none;
  border-radius: 8px;
  width: 141px;
  height: 42px;
}

::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}
::-webkit-scrollbar-button {
  background: #ccc;
}

::-webkit-scrollbar {
  width: 5px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: #888;
}

::-webkit-scrollbar-thumb:hover {
  background: #555;
}
.acc-transaction-header-wrapper {
  overflow: unset !important;
  z-index: 11 !important;
}
/* span.password-icon {
  color: #ffff;
  position: absolute;
  top: 10%;
  right: 4%;
  z-index: 111;
} */
.field.password-wrap {
  position: relative;
}
.transaction-info-wrap div {
  inline-size: 50%;
  overflow-wrap: break-word;
}

.tx-id-box h3 {
  font-size: 18px;
  margin: 0px;
  padding: 5px 10px;
  color: #383838;
}

.tx-id-box {
  border: 2px solid transparent;
  background: var(--buttonBorder);
  background-origin: border-box;
  border-radius: 6px;
  box-shadow: inset 2px 1000px 1px #fff;
  font-size: 19px;
}

.field.filter-field input {
  z-index: unset;
}

@media (max-width: 768px) {
  .tx-id-box h3 {
    font-size: 13px;
  }
}
@media (min-width: 500px) and (max-width: 768px) {
  .tx-id-box h3 {
    font-size: 18px;
  }
}
@media (min-width: 768px) and (max-width: 1599px) {
  .offcanvas-custom-large {
    width: 580px;
  }
}
@media (min-width: 1600px) {
  .tx-id-box h3 {
    font-size: 23px;
  }
}

.offcanvas-custom-large .offcanvas-header {
  border-bottom: none !important;
}

@media (min-width: 500px) and (max-width: 768px) {
  .offcanvas-custom-large {
    width: 480px !important;
  }
}

@media (min-width: 768px) and (max-width: 1599px) {
  .tx-id-box h3 {
    font-size: 18px !important;
  }
}

@media (min-width: 768px) and (max-width: 1599px) {
  .offcanvas-custom-large {
    width: 580px !important;
  }
}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
textarea:-webkit-autofill,
textarea:-webkit-autofill:hover,
textarea:-webkit-autofill:focus,
select:-webkit-autofill,
select:-webkit-autofill:hover,
select:-webkit-autofill:focus {
  background: none;
  -webkit-text-fill-color: #1A1919;
  -webkit-box-shadow: 0 0 0px 1000px #fff inset;
  -webkit-transition: background-color 5000s ease-in-out 0s;
  transition: background-color 5000s ease-in-out 0s;
}
button.disable-btn {
  background: #21252961 !important;
}
h3.disable-request {
  color: #FF360D !important;
}
td.dataTables_empty {
  display: none;
}

table thead tr th {
  white-space: nowrap;
  text-align: center;
}

tbody tr td {
  text-align: center;
}

thead tr th {
  padding: 10px 30px !important;
}





/**** ToolTip css **********/


/**** ToolTip css **********/
/* START TOOLTIP STYLES */
[tooltip] {
  position: relative; /* opinion 1 */
}

/* Applies to all tooltips */
[tooltip]::before,
[tooltip]::after {
  text-transform: none; /* opinion 2 */
  font-size: 0.9em; /* opinion 3 */
  line-height: 1;
  -webkit-user-select: none;
          user-select: none;
  pointer-events: none;
  position: absolute;
  display: none;
  opacity: 0;
}
[tooltip]::before {
  content: "";
  /* border: 5px solid transparent;  */
  z-index: 1001; /* absurdity 1 */
}
[tooltip]::after {
  content: attr(tooltip); /* magic! */
  font-family: Helvetica, sans-serif;
  text-align: center;
  max-width: 200px;
  min-width: 200px;
  /* min-height: 100px; */
  padding: 1ch 1.5ch;
  border-radius: 0.3ch;
  background: #fff;
  z-index: 1000; /* absurdity 2 */
  box-shadow: 0px 3px 6px #00000029;
  border: 1px solid ccc;
  color: #5d5d5d;
  font-size: 14px;
  white-space: normal;
  /* margin-left: -45px; */
}

/* Make the tooltips respond to hover */
[tooltip]:hover::before,
[tooltip]:hover::after {
  display: block;
}

/* don't show empty tooltips */
[tooltip=""]::before,
[tooltip=""]::after {
  display: none !important;
}

/* FLOW: RIGHT */
[tooltip][flow^="right"]::after {
  min-width: 15em;
  top: 50%;
  /* left: calc(28% + 3px); */
  left: calc(13% + 3px);
  transform: translate(0.5em, -50%);
}

/* FLOW: UP */
[tooltip]:not([flow])::before,
[tooltip][flow^="up"]::before {
  bottom: 100%;
  border-bottom-width: 0;
  /* border-top-color: #333; */
}
[tooltip]:not([flow])::after,
[tooltip][flow^="up"]::after {
  bottom: calc(100% + -10px);
}
[tooltip]:not([flow])::before,
[tooltip]:not([flow])::after,
[tooltip][flow^="up"]::before,
[tooltip][flow^="up"]::after {
  left: 67%;
  transform: translate(-50%, -0.5em);
}

/* FLOW: DOWN */
[tooltip][flow^="down"]::before {
  top: 100%;
  border-top-width: 0;
  border-bottom-color: #333;
}
[tooltip][flow^="down"]::after {
  top: calc(100% + 5px);
}
[tooltip][flow^="down"]::before,
[tooltip][flow^="down"]::after {
  left: 50%;
  transform: translate(-50%, 0.5em);
}

/* FLOW: LEFT */
[tooltip][flow^="left"]::before {
  top: 50%;
  border-right-width: 0;
  border-left-color: #333;
  left: calc(0em - 5px);
  transform: translate(-0.5em, -50%);
}

[tooltip][flow^="left"]::after {
  /* top: 50%; */
  right: calc(100% + 5px);
  transform: translate(-0.5em, -50%);
}

/* KEYFRAMES */
@keyframes tooltips-vert {
  to {
    opacity: 1;
    transform: translate(-50%, 0);
  }
}

@keyframes tooltips-horz {
  to {
    opacity: 1;
    transform: translate(0, -50%);
  }
}

/* FX All The Things */
[tooltip]:not([flow]):hover::before,
[tooltip]:not([flow]):hover::after,
[tooltip][flow^="up"]:hover::before,
[tooltip][flow^="up"]:hover::after,
[tooltip][flow^="down"]:hover::before,
[tooltip][flow^="down"]:hover::after {
  animation: tooltips-vert 300ms ease-out forwards;
}

[tooltip][flow^="left"]:hover::before,
[tooltip][flow^="left"]:hover::after,
[tooltip][flow^="right"]:hover::before,
[tooltip][flow^="right"]:hover::after {
  animation: tooltips-horz 300ms ease-out forwards;
}



.table-striped>tbody>tr:nth-of-type(odd)>* {
  --bs-table-bg-type: unset !important;
}


/* For Chrome, Safari, Edge, and Opera */
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* For Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}


`, "",{"version":3,"sources":["webpack://./src/custom.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,UAAU;AACZ;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,cAAc;EACd,2BAA2B;EAC3B,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,UAAU;EACV,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,0BAA0B;EAC1B,sBAAsB;AACxB;AACA;;;;;;GAMG;AACH;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,6BAA6B;EAC7B,kBAAkB;EAClB,qCAAqC;EACrC,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;;;;;;;;;EASE,gBAAgB;EAChB,gCAAgC;EAChC,6CAA6C;EAC7C,yDAAiD;EAAjD,iDAAiD;AACnD;AACA;EACE,gCAAgC;AAClC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;AAC/B;;;;;;AAMA,4BAA4B;;;AAG5B,4BAA4B;AAC5B,yBAAyB;AACzB;EACE,kBAAkB,EAAE,cAAc;AACpC;;AAEA,4BAA4B;AAC5B;;EAEE,oBAAoB,EAAE,cAAc;EACpC,gBAAgB,EAAE,cAAc;EAChC,cAAc;EACd,yBAAiB;UAAjB,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,aAAa;EACb,UAAU;AACZ;AACA;EACE,WAAW;EACX,oCAAoC;EACpC,aAAa,EAAE,gBAAgB;AACjC;AACA;EACE,sBAAsB,EAAE,WAAW;EACnC,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,aAAa,EAAE,gBAAgB;EAC/B,iCAAiC;EACjC,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA,uCAAuC;AACvC;;EAEE,cAAc;AAChB;;AAEA,8BAA8B;AAC9B;;EAEE,wBAAwB;AAC1B;;AAEA,gBAAgB;AAChB;EACE,eAAe;EACf,QAAQ;EACR,2BAA2B;EAC3B,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA,aAAa;AACb;;EAEE,YAAY;EACZ,sBAAsB;EACtB,4BAA4B;AAC9B;AACA;;EAEE,0BAA0B;AAC5B;AACA;;;;EAIE,SAAS;EACT,kCAAkC;AACpC;;AAEA,eAAe;AACf;EACE,SAAS;EACT,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,qBAAqB;AACvB;AACA;;EAEE,SAAS;EACT,iCAAiC;AACnC;;AAEA,eAAe;AACf;EACE,QAAQ;EACR,qBAAqB;EACrB,uBAAuB;EACvB,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,kCAAkC;AACpC;;AAEA,cAAc;AACd;EACE;IACE,UAAU;IACV,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,UAAU;IACV,6BAA6B;EAC/B;AACF;;AAEA,sBAAsB;AACtB;;;;;;EAME,gDAAgD;AAClD;;AAEA;;;;EAIE,gDAAgD;AAClD;;;;AAIA;EACE,oCAAoC;AACtC;;;AAGA,wCAAwC;AACxC;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA,gBAAgB;AAChB;EACE,0BAA0B;AAC5B","sourcesContent":[".show {\n  display: block !important;\n}\n\n.hide {\n  display: none;\n}\n.enter-digit {\n  text-align: center;\n  margin-top: 20px;\n}\n.error-msg {\n  color: red;\n}\n.twofa-guide-button.disable-btn {\n  margin-bottom: 20px;\n}\nbutton.rejected-application {\n  font-size: 18px;\n  color: #383838;\n  background-color: #e51010a6;\n  border: none;\n  border-radius: 8px;\n  width: 141px;\n  height: 42px;\n}\n\n::-webkit-scrollbar {\n  width: 5px;\n  height: 5px;\n}\n::-webkit-scrollbar-button {\n  background: #ccc;\n}\n\n::-webkit-scrollbar {\n  width: 5px;\n}\n\n::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n\n::-webkit-scrollbar-thumb {\n  background: #888;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n.acc-transaction-header-wrapper {\n  overflow: unset !important;\n  z-index: 11 !important;\n}\n/* span.password-icon {\n  color: #ffff;\n  position: absolute;\n  top: 10%;\n  right: 4%;\n  z-index: 111;\n} */\n.field.password-wrap {\n  position: relative;\n}\n.transaction-info-wrap div {\n  inline-size: 50%;\n  overflow-wrap: break-word;\n}\n\n.tx-id-box h3 {\n  font-size: 18px;\n  margin: 0px;\n  padding: 5px 10px;\n  color: #383838;\n}\n\n.tx-id-box {\n  border: 2px solid transparent;\n  background: var(--buttonBorder);\n  background-origin: border-box;\n  border-radius: 6px;\n  box-shadow: inset 2px 1000px 1px #fff;\n  font-size: 19px;\n}\n\n.field.filter-field input {\n  z-index: unset;\n}\n\n@media (max-width: 768px) {\n  .tx-id-box h3 {\n    font-size: 13px;\n  }\n}\n@media (min-width: 500px) and (max-width: 768px) {\n  .tx-id-box h3 {\n    font-size: 18px;\n  }\n}\n@media (min-width: 768px) and (max-width: 1599px) {\n  .offcanvas-custom-large {\n    width: 580px;\n  }\n}\n@media (min-width: 1600px) {\n  .tx-id-box h3 {\n    font-size: 23px;\n  }\n}\n\n.offcanvas-custom-large .offcanvas-header {\n  border-bottom: none !important;\n}\n\n@media (min-width: 500px) and (max-width: 768px) {\n  .offcanvas-custom-large {\n    width: 480px !important;\n  }\n}\n\n@media (min-width: 768px) and (max-width: 1599px) {\n  .tx-id-box h3 {\n    font-size: 18px !important;\n  }\n}\n\n@media (min-width: 768px) and (max-width: 1599px) {\n  .offcanvas-custom-large {\n    width: 580px !important;\n  }\n}\n\ninput:-webkit-autofill,\ninput:-webkit-autofill:hover,\ninput:-webkit-autofill:focus,\ntextarea:-webkit-autofill,\ntextarea:-webkit-autofill:hover,\ntextarea:-webkit-autofill:focus,\nselect:-webkit-autofill,\nselect:-webkit-autofill:hover,\nselect:-webkit-autofill:focus {\n  background: none;\n  -webkit-text-fill-color: #1A1919;\n  -webkit-box-shadow: 0 0 0px 1000px #fff inset;\n  transition: background-color 5000s ease-in-out 0s;\n}\nbutton.disable-btn {\n  background: #21252961 !important;\n}\nh3.disable-request {\n  color: #FF360D !important;\n}\ntd.dataTables_empty {\n  display: none;\n}\n\ntable thead tr th {\n  white-space: nowrap;\n  text-align: center;\n}\n\ntbody tr td {\n  text-align: center;\n}\n\nthead tr th {\n  padding: 10px 30px !important;\n}\n\n\n\n\n\n/**** ToolTip css **********/\n\n\n/**** ToolTip css **********/\n/* START TOOLTIP STYLES */\n[tooltip] {\n  position: relative; /* opinion 1 */\n}\n\n/* Applies to all tooltips */\n[tooltip]::before,\n[tooltip]::after {\n  text-transform: none; /* opinion 2 */\n  font-size: 0.9em; /* opinion 3 */\n  line-height: 1;\n  user-select: none;\n  pointer-events: none;\n  position: absolute;\n  display: none;\n  opacity: 0;\n}\n[tooltip]::before {\n  content: \"\";\n  /* border: 5px solid transparent;  */\n  z-index: 1001; /* absurdity 1 */\n}\n[tooltip]::after {\n  content: attr(tooltip); /* magic! */\n  font-family: Helvetica, sans-serif;\n  text-align: center;\n  max-width: 200px;\n  min-width: 200px;\n  /* min-height: 100px; */\n  padding: 1ch 1.5ch;\n  border-radius: 0.3ch;\n  background: #fff;\n  z-index: 1000; /* absurdity 2 */\n  box-shadow: 0px 3px 6px #00000029;\n  border: 1px solid ccc;\n  color: #5d5d5d;\n  font-size: 14px;\n  white-space: normal;\n  /* margin-left: -45px; */\n}\n\n/* Make the tooltips respond to hover */\n[tooltip]:hover::before,\n[tooltip]:hover::after {\n  display: block;\n}\n\n/* don't show empty tooltips */\n[tooltip=\"\"]::before,\n[tooltip=\"\"]::after {\n  display: none !important;\n}\n\n/* FLOW: RIGHT */\n[tooltip][flow^=\"right\"]::after {\n  min-width: 15em;\n  top: 50%;\n  /* left: calc(28% + 3px); */\n  left: calc(13% + 3px);\n  transform: translate(0.5em, -50%);\n}\n\n/* FLOW: UP */\n[tooltip]:not([flow])::before,\n[tooltip][flow^=\"up\"]::before {\n  bottom: 100%;\n  border-bottom-width: 0;\n  /* border-top-color: #333; */\n}\n[tooltip]:not([flow])::after,\n[tooltip][flow^=\"up\"]::after {\n  bottom: calc(100% + -10px);\n}\n[tooltip]:not([flow])::before,\n[tooltip]:not([flow])::after,\n[tooltip][flow^=\"up\"]::before,\n[tooltip][flow^=\"up\"]::after {\n  left: 67%;\n  transform: translate(-50%, -0.5em);\n}\n\n/* FLOW: DOWN */\n[tooltip][flow^=\"down\"]::before {\n  top: 100%;\n  border-top-width: 0;\n  border-bottom-color: #333;\n}\n[tooltip][flow^=\"down\"]::after {\n  top: calc(100% + 5px);\n}\n[tooltip][flow^=\"down\"]::before,\n[tooltip][flow^=\"down\"]::after {\n  left: 50%;\n  transform: translate(-50%, 0.5em);\n}\n\n/* FLOW: LEFT */\n[tooltip][flow^=\"left\"]::before {\n  top: 50%;\n  border-right-width: 0;\n  border-left-color: #333;\n  left: calc(0em - 5px);\n  transform: translate(-0.5em, -50%);\n}\n\n[tooltip][flow^=\"left\"]::after {\n  /* top: 50%; */\n  right: calc(100% + 5px);\n  transform: translate(-0.5em, -50%);\n}\n\n/* KEYFRAMES */\n@keyframes tooltips-vert {\n  to {\n    opacity: 1;\n    transform: translate(-50%, 0);\n  }\n}\n\n@keyframes tooltips-horz {\n  to {\n    opacity: 1;\n    transform: translate(0, -50%);\n  }\n}\n\n/* FX All The Things */\n[tooltip]:not([flow]):hover::before,\n[tooltip]:not([flow]):hover::after,\n[tooltip][flow^=\"up\"]:hover::before,\n[tooltip][flow^=\"up\"]:hover::after,\n[tooltip][flow^=\"down\"]:hover::before,\n[tooltip][flow^=\"down\"]:hover::after {\n  animation: tooltips-vert 300ms ease-out forwards;\n}\n\n[tooltip][flow^=\"left\"]:hover::before,\n[tooltip][flow^=\"left\"]:hover::after,\n[tooltip][flow^=\"right\"]:hover::before,\n[tooltip][flow^=\"right\"]:hover::after {\n  animation: tooltips-horz 300ms ease-out forwards;\n}\n\n\n\n.table-striped>tbody>tr:nth-of-type(odd)>* {\n  --bs-table-bg-type: unset !important;\n}\n\n\n/* For Chrome, Safari, Edge, and Opera */\ninput[type=\"number\"]::-webkit-inner-spin-button,\ninput[type=\"number\"]::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* For Firefox */\ninput[type=\"number\"] {\n  -moz-appearance: textfield;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
